<template>
    <div class="meetingplan-view">
        <div class="field-block">
            <div class="field-row field-row-line">
                <div class="field-title field-title-meetingName">{{addNewOrEditData.meetingName}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('meetingSystem', true)">系统选择<common-tooltip class="field-input-no-title-tooltip" isView tipCode="8"></common-tooltip><span>*</span></div>
                <div class="field-value">{{basedataGetName('MeetingSystem', addNewOrEditData.meetingSystem)}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('meetingModality', true)">是否网络会议<span>*</span></div>
                <div class="field-value">{{basedataGetName('MeetingModality', addNewOrEditData.meetingModality)}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('meetingProp', true)">会议性质<span>*</span></div>
                <div class="field-value">{{basedataGetName('MeetingProp', addNewOrEditData.meetingProp)}}</div>
            </div>
            <div class="field-row" v-if="meetingSystemType != 'GSD'">
                <div class="field-title" :class="required('meetingType', true)">A1会议类型<span>*</span></div>
                <div class="field-value">{{basedataGetName('MeetingType', addNewOrEditData.meetingType)}}</div>
            </div>
            <div class="field-row" v-if="meetingSystemType != 'A1'">
                <div class="field-title" :class="required('meetingGsdType', true)">GSD项目类型<span>*</span></div>
                <div class="field-value">{{basedataGetName('MeetingGsdType', addNewOrEditData.meetingGsdType)}}</div>
            </div>
            <div class="field-row" v-if="meetingSystemType != 'A1'">
                <div class="field-title" :class="required('meetingGsdSubType', true)">GSD细类<span>*</span></div>
                <div class="field-value">{{basedataGetName('MeetingGsdTypeSub'+addNewOrEditData.meetingGsdType, addNewOrEditData.meetingGsdSubType)}}</div>
            </div>
        </div>
        <div class="field-block">
            <div class="field-row">
                <div class="field-title" :class="required('departId', true)">部门<span>*</span></div>
                <div class="field-value">{{basedataGetName('Depart', addNewOrEditData.departId)}}</div>
            </div>
            <div class="field-row">
                <div class="field-title field-title-more-lines" :class="required('medicalField', true)">Franchise/DA<span>*</span></div>
                <div class="field-value">{{basedataGetName('MedicalField', addNewOrEditData.medicalField)}}</div>
            </div>
            <div class="field-row">
                <div class="field-title field-title-more-lines" :class="required('medicalField', true)">团队<span>*</span></div>
                <div class="field-value">{{basedataGetName('Teams', addNewOrEditData.teamL4)}}</div>
            </div>
            <div class="field-row" v-if="basedataGetName('MeetingProp',addNewOrEditData.meetingProp) == '推广'">
                <div class="field-title" :class="required('treatmentArea', basedataGetName('MeetingProp',addNewOrEditData.meetingProp) == '推广')">治疗领域<span>*</span></div>
                <div class="field-value">{{basedataGetName('TreatmentArea', addNewOrEditData.treatmentArea)}}</div>
            </div>
            <div class="field-row" v-if="basedataGetName('MeetingProp',addNewOrEditData.meetingProp) == '非推广'">
                <div class="field-title" :class="required('diseaseArea', basedataGetName('MeetingProp',addNewOrEditData.meetingProp).indexOf('非推广') >= 0)">治疗领域<span>*</span></div>
                <div class="field-value">{{basedataGetName('DiseaseArea', addNewOrEditData.diseaseArea)}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('productId', true)">产品(多选)<span>*</span></div>
            </div>
            <div class="field-row">
                <div class="field-value field-value-left">{{basedataGetName('Product', addNewOrEditData.productId)}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('companyStrategy', true)">公司战略(多选)<span>*</span></div>
            </div>
            <div class="field-row">
                <div class="field-value field-value-left">{{basedataGetName('CompanyStrategy', addNewOrEditData.companyStrategy)}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('strategyKeynote', true)">策略重点(多选)<span>*</span></div>
            </div>
            <div class="field-row">
                <div class="field-value field-value-left">{{addNewOrEditData.strategyKeynoteName}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('medicalFieldResult', meetingSystemType != 'A1')">治疗领域业务结果(多选)<span>*</span></div>
            </div>
            <div class="field-row">
                <div class="field-value field-value-left">{{addNewOrEditData.medicalFieldResultName}}</div>
            </div>
            <div v-if="addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0" class="field-row">
                <div class="field-title">治疗领域业务结果（自定义描述）</div>
            </div>
            <div v-if="addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0" class="field-row">
                <div class="field-value field-value-left">{{addNewOrEditData.medicalFieldResultDes}}</div>
            </div>
        </div>
        <div class="field-block">
            <div class="field-row">
                <div class="field-title" :class="required('meetingBeginDate', true)">开始日期<span>*</span></div>
                <div class="field-value">{{addNewOrEditData.meetingBeginDate}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('meetingEndDate', true)">结束日期<span>*</span></div>
                <div class="field-value">{{addNewOrEditData.meetingEndDate}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('meetingTimeInt', meetingSystemType != 'GSD')">会议时段<span>*</span></div>
                <div class="field-value">{{basedataGetName('MeetingTimeInt', addNewOrEditData.meetingTimeInt)}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('country', meetingSystemType != 'GSD')">国家<span>*</span></div>
                <div class="field-value">{{addNewOrEditData.countryName}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('province', meetingSystemType != 'GSD')">省份<span>*</span></div>
                <div class="field-value">{{addNewOrEditData.provinceName}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('city', meetingSystemType != 'GSD')">城市<span>*</span></div>
                <div class="field-value">{{addNewOrEditData.cityName}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('meetingPlace', meetingSystemType != 'GSD' && basedataGetName('MeetingModality',addNewOrEditData.meetingModality).indexOf('线下') >= 0)">会议地点<span>*</span></div>
                <div class="field-value">{{addNewOrEditData.meetingPlace}}</div>
            </div>
        </div>
        <div class="field-block">  
            <div v-if="meetingSystemType != 'A1'"> 
                <div class="field-row">
                    <div class="field-title" :class="required('recipientSocietyOrHospital',meetingSystemType != 'A1',true)">受赠方类型<span>*</span></div>
                    <div class="field-value">{{recipientSocietyOrHospitalOptions.find(r => r.value === recipientSocietyOrHospital).label}}</div>
                </div>
            </div> 
            <div class="field-row" v-if="meetingSystemType != 'A1' && recipientSocietyOrHospital != '0'">
                <div class="field-title" :class="required('recipientSocietyStr', true)">受赠方名称<common-tooltip class="field-input-no-title-tooltip" isView tipCode="11"></common-tooltip><span>*</span></div>
                <div class="field-value">{{addNewOrEditData.recipientSocietyStr || addNewOrEditData.universityStr || addNewOrEditData.patientOrgStr || addNewOrEditData.otherStr}}</div>
            </div>
            <div v-if="(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && !isOneHospital()"> 
                <div class="field-row field-row-middle">
                    <div class="field-title" :class="required('moreThenOneHospital', (meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && !isOneHospital())">医院总数<span>*</span></div>
                </div>
                <div class="field-row field-row-middle">
                    <mt-checklist
                        class="radio"
                        v-model="moreThenOneHospitalArray"
                        :options="moreThenOneHospitalOptions">
                    </mt-checklist>
                </div>   
            </div> 
            <div class="field-row field-row-middle more-tab-div" v-if="(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0')">
                <div class="more-tab">
                    <div class="field-row-inner">
                        <div class="field-title" :class="required('hospitalLevelId', meetingSystemType != 'GSD')">医院层级<common-tooltip class="field-input-no-title-tooltip" isView tipCode="9"></common-tooltip><span>*</span></div>
                        <div class="field-value">{{addNewOrEditData.hospitalLevelName}}</div>
                    </div>
                    <div class="field-row-inner" v-if="moreThenOneHospital == 1 && !isOneHospital()">
                        <div class="field-title" :class="required('hospitalCount', meetingSystemType != 'GSD')">医院数量<span>*</span></div>
                        <div class="field-value">{{addNewOrEditData.hospitalCount}}</div>
                    </div>
                    <div class="field-row-inner" v-if="!(moreThenOneHospital == 1 && !isOneHospital())">
                        <div class="field-title" :class="required('hospitalId', (meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && !(moreThenOneHospital == 1 && !isOneHospital()))">医院<span>*</span></div>
                        <div class="field-value">{{addNewOrEditData.hospitalName}}</div>
                    </div>
                </div>
            </div>
            <div class="field-row field-row-middle more-tab-div" v-for="(hospital,index) in addNewOrEditData.extendData.hospitalInfos" :key="index">
                <div class="more-tab">                        
                    <div class="field-row-inner">
                        <div class="field-title" :class="required('extendData.hospitalInfos.'+index+'.hospitalLevelId', meetingSystemType != 'GSD')">医院层级<common-tooltip class="field-input-no-title-tooltip" isView tipCode="9"></common-tooltip><span>*</span></div>
                        <div class="field-value">{{hospital.hospitalLevelName}}</div>
                    </div>
                    <div class="field-row-inner">
                        <div class="field-title" :class="required('extendData.hospitalInfos.'+index+'.hospitalCount', meetingSystemType != 'GSD')">医院数量<span>*</span></div>
                        <div class="field-value">{{hospital.hospitalCount}}</div>
                    </div>
                </div>
            </div>
            <div v-if="(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0')"  class="field-row field-row-top">
                <div class="field-title" :class="required('offices', meetingSystemType != 'GSD')">科室(多选)<span>*</span></div>
            </div>
            <div v-if="(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0')"  class="field-row">
                <div class="field-value field-value-left">{{basedataGetName('Office', addNewOrEditData.offices)}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('includeSpeaker', true)">是否包含讲者<span>*</span></div>
            </div>
            <div class="field-row field-row-middle">
                <mt-checklist
                    class="radio"
                    v-model="includeSpeakerArray"
                    :options="includeSpeakerOptions">
                </mt-checklist>
            </div>  
            <div v-if="addNewOrEditData.includeSpeaker == 1" class="field-block-inner">
                <div class="field-row field-row-middle more-tab-div">
                    <div class="more-tab">
                        <div class="field-row-inner">
                            <div class="field-title" :class="required('speakerLevel', addNewOrEditData.includeSpeaker == 1 && meetingSystemType != 'GSD')">讲者级别<common-tooltip class="field-input-no-title-tooltip" isView tipCode="10"></common-tooltip><span>*</span></div>
                            <div class="field-value">{{addNewOrEditData.speakerLevelName}}</div>
                        </div>
                        <div class="field-row-inner">
                            <div class="field-title" :class="required('speakerCount', addNewOrEditData.includeSpeaker == 1 && meetingSystemType != 'GSD')">讲者人数<span>*</span></div>
                            <div class="field-value">{{addNewOrEditData.speakerCount}}</div>
                        </div>
                    </div>
                </div>
                <div class="field-row field-row-middle more-tab-div" v-for="(speaker,index) in addNewOrEditData.extendData.speakerInfos" :key="index">
                    <div class="more-tab">
                        <div class="field-row-inner">
                            <div class="field-title" :class="required('extendData.speakerInfos.'+index+'.speakerLevel', addNewOrEditData.includeSpeaker == 1 && meetingSystemType != 'GSD')">讲者级别<common-tooltip class="field-input-no-title-tooltip" isView tipCode="10"></common-tooltip><span>*</span></div>
                            <div class="field-value">{{speaker.speakerLevelName}}</div>
                        </div>
                        <div class="field-row-inner">
                            <div class="field-title" :class="required('extendData.speakerInfos.'+index+'.speakerCount', addNewOrEditData.includeSpeaker == 1 && meetingSystemType != 'GSD')">讲者人数<span>*</span></div>
                            <div class="field-value">{{speaker.speakerCount}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field-row" :class="addNewOrEditData.includeSpeaker == 1?'field-row-top':''">
                <div class="field-title" :class="required('attendCount', true)">参会者人数<span>*</span></div>
                <div class="field-value">{{addNewOrEditData.attendCount}}</div>
            </div>
            <div class="field-row">
                <div class="field-title" :class="required('rocheCount', true)">罗氏员工人数（内）<span>*</span></div>
                <div class="field-value">{{addNewOrEditData.rocheCount}}</div>
            </div>
        </div>
        <div class="field-block">            
            <div class="field-row">
                <div class="field-title" :class="required('totalAmount', true)">会议总预算(CNY)<common-tooltip class="field-input-no-title-tooltip" isView tipCode="12"></common-tooltip><span>*</span></div>
                <div class="field-value">{{addNewOrEditData.totalAmount}}</div>
            </div>
            <div v-if="addNewOrEditData.meetingSystem.length == 2">           
                <div class="field-row-inner">
                    <div class="field-title" :class="required('a1Amount', addNewOrEditData.meetingSystem.length == 2)" v-show="addNewOrEditData.meetingSystem.length == 2">A1预算<span>*</span></div>
                    <div class="field-value">{{addNewOrEditData.a1Amount}}</div>
                </div>          
                <div class="field-row-inner">
                    <div class="field-title" :class="required('gsdAmount', addNewOrEditData.meetingSystem.length == 2)" v-show="addNewOrEditData.meetingSystem.length == 2">GSD预算<span>*</span></div>
                    <div class="field-value">{{addNewOrEditData.gsdAmount}}</div>
                </div>
            </div>           
            <div class="field-row">
                <div class="field-title" :class="required('costCenter', true)">成本中心<span>*</span></div>
                <div class="field-value">{{addNewOrEditData.costCenter + ' ' + addNewOrEditData.costCenterName}}</div>
            </div>          
            <div class="field-row">
                <div class="field-title">WBS code</div>
                <div class="field-value">{{addNewOrEditData.wbsCode}}</div>
            </div>         
            <div class="field-row">
                <div class="field-title">会议申请人</div>
                <div class="field-value">{{addNewOrEditData.meetingOrganizerCnname + ' ' + addNewOrEditData.meetingOrganizerName}}</div>
            </div>
        </div>
        <div class="workflow" @click="showWorkflow = !showWorkflow">
            <div class="workflow-dropdown-icon">
                <span :class="['iconfont',showWorkflow?'icon-jiantou_shang':'icon-jiantou_xia']"></span>
            </div>
            <span class="workflow-title">审批流</span>
        </div>
        <div class="field-block" v-show="showWorkflow">
            <div v-for="(node, index) in addNewOrEditData.nodeList" :key="node.id">
                <div :class="['field-row-inner',index == 0?'field-row-first':'']">
                    <div class="field-title field-title-status">{{node.nodeLevel}}</div>                
                </div>
                <div :class="['field-row-inner', (!node.remark && index == addNewOrEditData.nodeList.length-1)?'field-row-last':'']">
                    <div class="field-value field-value-left field-value-status">{{node.realName}} {{node.username}}<br/>{{node.createTime | TimeFormat}}</div>      
                    <span :class="['approval-status', approvalStatusClass(node.meetStatus)]">{{node.statusName}}</span>          
                </div>
                <div v-if="node.remark" :class="['field-row-inner', (index == addNewOrEditData.nodeList.length-1)?'field-row-last':'']">
                    <div class="field-value field-value-left field-value-status">{{node.remark}}</div>      
                </div>
            </div>
        </div>
        <div class="bottom-info" v-if="false">
        </div>
    </div>
</template>
<script>
import application from '@/api/meetingplan/application';
import { mapGetters } from 'vuex';
import { MessageBox  } from 'mint-ui';

export default {
  data() {
    return {
      addNewOrEditData: {
          meetingName: '',
          meetingType: '',
          meetingGsdType: '',
          meetingGsdSubType: '',
          meetingProp: '',
          meetingModality: '',
          meetingSystem: [],
          departId: '',
          medicalField: '',
          treatmentArea: '',
          diseaseArea: '',
          productId: [],
          companyStrategy: [],
          strategyKeynote: [],
          medicalFieldResult: [],
          medicalFieldResultDes: '',
          meetingBeginDate: '',
          meetingEndDate: '',
          meetingTimeInt: '',
          country: '',
          province: '',
          city: '',
          meetingPlace: '',
          hospitalLevelId: '',
          hospitalCount: '',
          hospitalName: '',
          recipientSociety: '',
          universityStr: '',
          patientOrgStr: '',
          otherStr: '',
          offices: [],
          speakerLevel: '',
          speakerCount: '',
          attendCount: '',
          rocheCount: '',
          totalAmount: '',
          costCenter: '',
          wbsCode: '',
          a1Amount: '',
          gsdAmount: '',
          meetingOrganizer: '',
          includeSpeaker: '',
            extendData:{
                hospitalInfos: [],
                speakerInfos: [],
            },
      },
      addNewOrEditDataValidation: {
      },
      confirmChangeVisible: false,
      confirmCancleVisible: false,
      showWorkflow: true,
      recipientSocietyOrHospital: '1',
      moreThenOneHospitalArray: [],
      moreThenOneHospital: 0,
      includeSpeakerArray: [],
      recipientSocietyOrHospitalOptions: [
        {
            label: '受赠学会',
            value: '1',
            disabled: false,
        },
        {
            label: '医院',
            value: '0',
            disabled: false,
        },
        {
            label: '大学',
            value: '2',
            disabled: false,
        },
        {
            label: '患者组织',
            value: '3',
            disabled: false,
        },
        {
            label: '其他',
            value: '4',
            disabled: false,
        },
      ],
      moreThenOneHospitalOptions: [
        {
            label: '一家',
            value: '0',
            disabled: true,
        },
        {
            label: '两家及以上',
            value: '1',
            disabled: true,
        },
      ],
      includeSpeakerOptions: [
        {
            label: '是',
            value: '1',
            disabled: true,
        },
        {
            label: '否',
            value: '0',
            disabled: true,
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['baseDataRecords','basedataGetName','basedataGetIdByName','basedataGetObject']),
    includeSpeakerBoolean: {
        get() {
            return this.addNewOrEditData.includeSpeaker?true:false;
        },
        set(val) {
            this.addNewOrEditData.includeSpeaker = val?1:0;
        }
    },
    meetingSystemType() {
        //GSD、A1、All、None
        if(this.addNewOrEditData.meetingSystem.length == 0) {
            return 'None';
        }
        if(this.addNewOrEditData.meetingSystem.length == 2) {
            return 'All';
        }
        if(this.addNewOrEditData.meetingSystem.length == 1) {
            return this.basedataGetName('MeetingSystem',this.addNewOrEditData.meetingSystem)
        }
    },
  },
  methods: {
    required(field, isRequired, thisField = false) {
        if(!this.addNewOrEditDataValidation[field]) {
            this.addNewOrEditDataValidation[field] = {
                required: false,
                error: false,
            }
        }

        this.addNewOrEditDataValidation[field].required = isRequired;

        if(isRequired && !this.addNewOrEditDataValidation[field].unwatch) {
            let watchField = (thisField?'':'addNewOrEditData.')+field;
            this.addNewOrEditDataValidation[field].unwatch = this.$watch(watchField, function (newVal, oldVal) {
                this.$nextTick(() => {
                    if(this.addNewOrEditDataValidation[field].required) {
                        if(Array.isArray(newVal)) {
                            this.addNewOrEditDataValidation[field].error = newVal.length == 0;
                        }
                        else{
                            this.addNewOrEditDataValidation[field].error = !(newVal || newVal === 0);
                        }
                        
                        this.$forceUpdate();
                    }   
                })   
            })
        }
        if(!isRequired){
            if(this.addNewOrEditDataValidation[field].unwatch) {
                this.addNewOrEditDataValidation[field].unwatch();
                this.addNewOrEditDataValidation[field].unwatch = null;
            }
            this.addNewOrEditDataValidation[field].error = false;
        }

        let cls = [
            this.addNewOrEditDataValidation[field].required?'field-row-required':'',
            this.addNewOrEditDataValidation[field].error?'field-row-error':'',
        ]
        return cls;
    },
    approvalStatusClass(status) {
        switch (status) {
            case '2':                
                return 'approval-submit' 
            case '3':                
                return 'approval-padding'                
            case '4':                
                return 'approval-comfirm'              
            case '5':                
                return 'approval-reject'              
            case '7':                
                return 'approval-cancle'
        }
        return ''
    },
    showHospitalName(hospitalObj) {
        return hospitalObj.hospitalCount == 1 || 
                this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '科室会' || 
                this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '院内会';
    },   
    cancleTemplate(message) {
        var tempate = 
                '<div class="message-alert">'+
                    '<div>'+
                        '<i class="iconfont icon-jingshi"></i>'+
                    '</div>'+
                    '<div class="common-confirm-info">'+
                        '确认取消会议？'+                                            
                        '<div>' +
                            '（确认取消后将无法恢复）' +
                        '</div>' +
                    '</div>'+  
                '</div>';
        return tempate;
    },
    handleCancleClick() {
        MessageBox({
            message: this.cancleTemplate(),
            title: '',
            cancelButtonText: '返回',
            confirmButtonText: '确认',
            showCancelButton: true,
        }).then((action) => {
            if(action != 'cancel') {
                this.handlerCancleConfirmOK()
            }
        });
    },
    handlerCancleConfirmOK() {
        application.cancle({id:this.addNewOrEditData.id})
                    .then(res => {
                        history.back();
                    });
    },    
    changeTemplate(message) {
        var tempate = 
                '<div class="message-alert">'+
                    '<div>'+
                        '<i class="iconfont icon-jingshi"></i>'+
                    '</div>'+
                    '<div class="common-confirm-info">'+
                        '确认变更会议？'+
                    '</div>'+
                '</div>';
        return tempate;
    },
    handlerChangeClick() {
        MessageBox({
            message: this.changeTemplate(),
            title: '',
            cancelButtonText: '返回',
            confirmButtonText: '确认',
            showCancelButton: true,
        }).then((action) => {
            if(action != 'cancel') {
                this.handlerChangeConfirmOK()
            }
        });
    },
    handlerChangeConfirmOK() {
        this.$router.push({
            name: 'meetingplan-application-change',
            params: {'id':this.addNewOrEditData.id}
        }); 
    },
    isOneHospital(hospitalObj) {
        return this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '科室会' || 
                this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '院内会';
    },
    setRecipientSocietyOrHospital(val) {
        this.recipientSocietyOrHospital = val;
    },
    setMoreThenOneHospitall(val) {
        this.moreThenOneHospital = val;
        this.addNewOrEditData.moreThenOneHospital = val;
        this.moreThenOneHospitalArray = [val.toString()];
    },
  },  
  mounted() {    
    application.queryById({id:this.$route.params.id})
                .then(res => {
                    //转换多选项
                    res.companyStrategy = res.companyStrategy.split(',');
                    res.medicalFieldResult = res.medicalFieldResult.split(',');
                    res.meetingSystem = res.meetingSystem.split(',');
                    res.offices = res.offices.split(',');
                    res.productId = res.productId.split(',');
                    res.strategyKeynote = res.strategyKeynote.split(',');

                    //新需求字段初始化
                    res.meetingGsdType = res.meetingGsdType || '';
                    res.meetingGsdSubType = res.meetingGsdSubType || '';
                    res.universityStr = res.universityStr || '';
                    res.patientOrgStr = res.patientOrgStr || '';
                    res.otherStr = res.otherStr || '';
                    res.teamL4 = res.teamL4 || '';
                    
                    res.extendData = {
                        hospitalInfos:[],
                        speakerInfos:[],
                    };
                    //转换医院信息
                    if(res.pubMeetingHospitalLevelList.length > 0) {
                        res.hospitalLevelId = res.pubMeetingHospitalLevelList[0].hospitalLevelId;
                        res.hospitalLevelName = res.pubMeetingHospitalLevelList[0].hospitalLevelName;
                        res.hospitalCount = res.pubMeetingHospitalLevelList[0].count;
                        res.hospitalName = res.pubMeetingHospitalLevelList[0].hospitalName;
                        res.recipientSociety = res.pubMeetingHospitalLevelList[0].recipientSociety;
                    }
                    if(res.pubMeetingHospitalLevelList.length > 1) {
                        for (let index = 1; index < res.pubMeetingHospitalLevelList.length; index++) {
                            const element = res.pubMeetingHospitalLevelList[index];

                            res.extendData.hospitalInfos.push({
                                hospitalLevelId : element.hospitalLevelId,
                                hospitalLevelName : element.hospitalLevelName,
                                hospitalCount : element.count,
                                hospitalName : element.hospitalName,
                                recipientSociety : element.recipientSociety,
                            })
                        }
                    }
                    res.pubMeetingHospitalLevelList = '';

                    //转换讲者信息
                    res.includeSpeaker = res.pubMeetingSpeakerLevelList.length > 0? 1 :0;
                    if(res.pubMeetingSpeakerLevelList.length > 0) {
                        res.speakerLevel = res.pubMeetingSpeakerLevelList[0].speakerLevel;
                        res.speakerLevelName = res.pubMeetingSpeakerLevelList[0].speakerLevelName;
                        res.speakerCount = res.pubMeetingSpeakerLevelList[0].count;
                    }
                    if(res.pubMeetingSpeakerLevelList.length > 1) {
                        for (let index = 1; index < res.pubMeetingSpeakerLevelList.length; index++) {
                            const element = res.pubMeetingSpeakerLevelList[index];

                            res.extendData.speakerInfos.push({
                                speakerLevel : element.speakerLevel,
                                speakerLevelName : element.speakerLevelName,
                                speakerCount : element.count,
                            })
                        }
                    }
                    res.pubMeetingSpeakerLevelList = '';

                    res.meetingBeginDate = moment(res.meetingBeginDate).format('YYYY-MM-DD');
                    res.meetingEndDate = moment(res.meetingEndDate).format('YYYY-MM-DD');

                    this.addNewOrEditData = res;

                    this.includeSpeakerArray = [this.addNewOrEditData.includeSpeaker.toString()];

                    if(this.addNewOrEditData.extendData.hospitalInfos.length > 0) {
                        this.setRecipientSocietyOrHospital('0');
                        this.setMoreThenOneHospitall(1);
                    }
                    else {
                        if(this.addNewOrEditData.hospitalId || this.addNewOrEditData.hospitalCount > 0) {
                            if(this.addNewOrEditData.hospitalCount > 1) {
                                this.setRecipientSocietyOrHospital('0');
                                this.setMoreThenOneHospitall(1);
                            }
                            else {
                                this.setRecipientSocietyOrHospital('0');
                                this.setMoreThenOneHospitall(0);                                 
                            }
                        }
                        else {
                            if(this.addNewOrEditData.recipientSocietyStr) {
                                this.setRecipientSocietyOrHospital('1');
                            }
                            if(this.addNewOrEditData.universityStr) {
                                this.setRecipientSocietyOrHospital('2');
                            }
                            if(this.addNewOrEditData.patientOrgStr) {
                                this.setRecipientSocietyOrHospital('3');
                            }
                            if(this.addNewOrEditData.otherStr) {
                                this.setRecipientSocietyOrHospital('4');
                            }
                            this.setMoreThenOneHospitall(0);
                        }
                    }

                    this.$parent.hiddenBottomInfo(true);
                })
  }
};
</script>

<style lang="less" scoped>
    .field-block {
        font-size: @subSubFontSize;
        color: @subSubFontColor;
        margin: 0 10px;
        padding-top: 10px;

        .more-tab {
            margin-right: 15px;
            margin-left: 15px;
            border: 1px solid #E7E7E7;
            border-radius: 2px;
            position: relative;
            width: 100%;

            .field-row {
                padding-left: 15px;
            }
        }

        .more-tab + .more-tab, .more-tab-div + .more-tab-div {
            padding-top: 10px;
        }

        .recipientSocietyOrHospital-text {
            height: auto !important;
            line-height: inherit !important;
            padding: 10px 15px 10px 0px !important;

            span{
                color: @mainColor;
                display: inline !important;
            }
        }

        .field-title-more-lines {
            height: auto !important;
            line-height: 20px !important;
        }

        .field-title {
            height: 35px;
            line-height: 35px;
            margin-left: 15px;
            color: @contentFontColor;

            &-meetingName {       
                font-weight: bold;   
                color: @subSubFontColor;     
            }

            &-status {
                font-weight: bold;   
                color: @subSubFontColor;
            }           

            span {
                display: none;
            }
        }

        .field-title.field-row-required {
            span {
                display: inline !important;
                color: #e64100;
                margin-left: 5px;
            }

            .field-input-no-title {
                span {                    
                    display: inline !important;
                    color: #e64100;
                    margin-left: 5px;
                }
            }
        }

        .field-row-required {
            .field-input-no-title {
                span {                    
                    display: inline !important;
                    color: #e64100;
                    margin-left: 5px;
                }
            }            

            .field-input-no-title-tooltip {
                margin-left: 0px !important;
            }
        }

        .field-value {            
            min-height: 35px;
            line-height: 35px;
            margin-left: auto;
            padding-right: 15px;

            &-left {
                margin-left: 15px;
            }

            &-status {
                color: @subSubFontColor;  
                width: 240px;              
            }
        }

        .field-row-line {
            border-bottom: 1px solid #E7E7E7;;
        }

        .field-row-space {
            height: 10px;
        }
        
        .field-row, .field-row-inner {
            background-color: #fff;
            min-height: 35px;
            display: flex;
            position: relative;
        }

        .field-row {
            .recipientSociety-tooltip {
                position: absolute;
                left: 130px;
            }
        }        

        .field-row-top {
            padding-top: 10px;
        }

        .field-row-middle:not(:first-child) {
            border-radius: 0px !important;
        }

        .field-row-middle:first-child {
            padding-top: 10px;
        }
        
        .field-block-inner {
            .field-row-middle {
                    border-radius: 0px !important;
            }
        }

        .field-row:nth-of-type(1),.field-row-first {
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        }

        .field-row:last-child, .field-row-last {
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
        }
    }
    .bottom-info {
        position: fixed;
        bottom: 0px;
        width: 375px;
        height: 61px;
        line-height: 44px;
        background: #ffffff;
        box-shadow: 0px -0.5px 0px 0px #e8eaec; 
        display: flex;
        font-size: 12px;
        border-bottom: 1px solid #e8eaec;

        button {
            margin: 10px auto;
        }

        button.left {
            margin: 10px 62.75px;
        }
    }

    

    .approval-status {
        height: 35px;
        line-height: 35px;
        margin-left: auto;
        padding-right: 15px;
    }

    .approval-padding {
        color: #FFB52A;
    }

    .approval-comfirm {
        color: #0EC771;
    }

    .approval-reject {
        color: #FB304D;
    }

    .approval-cancle {
        color: #666666;
    }

    .approval-submit {
        color: #2D82F0;
    }

    .workflow {
        margin: 10px 0 0 15px; 
        display: flex;

        &-title {
            font-size: 12px;
            color: @contentFontColor;
        }
    }

</style>


// WEBPACK FOOTER //
// index.vue?5c230a01